"use strict";
/**
 * @module diffusion.datatypes
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A class representing a slice of a buffer
 */
var BufferSlice = /** @class */ (function () {
    /**
     * Create a new buffer slice
     *
     * @param  buffer  the internal buffer
     * @param  offset  the offset of the slice
     * @param  length  the number of bytes in the slice
     */
    function BufferSlice(buffer, offset, length) {
        if (offset === void 0) { offset = 0; }
        if (length === void 0) { length = buffer.length; }
        this.$buffer = buffer;
        this.$offset = offset;
        this.$length = length;
    }
    return BufferSlice;
}());
exports.BufferSlice = BufferSlice;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/data/buffer-slice.js
// module id = 356
// module chunks = 1